let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("c41dA")).then(() => parcelRequire('Zu92b'));